import { render, staticRenderFns } from "./fileInputNOLIMIT.vue?vue&type=template&id=2afac1fb&scoped=true"
import script from "./fileInputNOLIMIT.vue?vue&type=script&lang=js"
export * from "./fileInputNOLIMIT.vue?vue&type=script&lang=js"
import style0 from "./fileInputNOLIMIT.vue?vue&type=style&index=0&id=2afac1fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afac1fb",
  null
  
)

export default component.exports